import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaseTypeLookupComponent } from './case-type-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [CaseTypeLookupComponent],
  exports: [CaseTypeLookupComponent],
  providers: []
})
export class CaseTypeLookupModule { }
